import React from "react";

import { cn } from "../../../common/u1/cn";
import { CheckIcon, SparkleIcon } from "../../../../assets/ui/icons";

/* The navy banner at the top of /u1/membership/:companyId. */
const VerifiedBadge = () => (
  <span
    aria-hidden="true"
    className="relative hidden shrink-0 items-center justify-center md:flex"
  >
    {/* The rays: eight bars on a circle, drawn once rather than as eight
        hand-placed elements. */}
    <span className="absolute h-[190px] w-[190px]">
      {Array.from({ length: 12 }).map((_, i) => (
        <span
          key={i}
          className="absolute left-1/2 top-1/2 h-[14px] w-[4px] rounded-full bg-[var(--coral)]"
          style={{
            transform: `translate(-50%, -50%) rotate(${i * 30}deg) translateY(-84px)`,
          }}
        />
      ))}
    </span>
    <span className="relative flex h-[130px] w-[130px] items-center justify-center rounded-full bg-white/10">
      <span className="flex h-[104px] w-[104px] items-center justify-center rounded-full bg-[var(--coral)] text-white shadow-[shadow:var(--coral-glow)]">
        <CheckIcon size={46} />
      </span>
    </span>
  </span>
);

export const MembershipHero = ({ companyName, className = "" }) => (
  <section
    className={cn(
      "relative overflow-hidden rounded-[18px] bg-[var(--navy)] px-6 py-9 sm:px-10 sm:py-11",
      className
    )}
  >
    {/* The coral wash from the top right. aria-hidden: it is texture, not
        content. */}
    <span
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 opacity-40"
      style={{
        background:
          "radial-gradient(60% 100% at 100% 0%, var(--coral) 0%, transparent 60%)",
      }}
    />

    <div className="relative flex items-center justify-between gap-8">
      <div className="min-w-0">
        <span
          className={cn(
            "inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5",
            "text-[11px] font-bold uppercase tracking-[.09em] text-[var(--coral-soft)] font-sans"
          )}
        >
          <SparkleIcon size={12} />
          Final step
        </span>

        <h1
          className={cn(
            "mb-0 mt-3.5 max-w-[620px] text-[30px] font-bold leading-[1.08]",
            "tracking-[-.02em] text-white font-sans sm:text-[40px]"
          )}
        >
          Become a <span className="text-[var(--coral)]">Member</span> of TREVEX
        </h1>

        <p className="mb-0 mt-3.5 max-w-[540px] text-[14.5px] leading-[1.55] text-white/70 font-sans">
          You&apos;ve claimed <b className="font-bold text-white">{companyName}</b>.
          Become a member to stand out, win more business, and build trust with
          every party you trade with.
        </p>
      </div>

      <VerifiedBadge />
    </div>
  </section>
);

export default MembershipHero;
